"use client";
import React, { useEffect, useState } from "react";
import HeroBlock from "./Components/Block_Components/heroBlock/page";
import { ServicesSection } from "./Components/Block_Components/servicesBlock/ServicesBlock";
import { NewsSection } from "./Components/Block_Components/newsBlock/NewsBlock";
import { ContactsSection } from "./Components/Block_Components/contactsBlock/ContactsSection";
import StatisticsGrid from "./Components/Element_Components/statistics/stastics";
import WelcomeBlock from "./Components/Block_Components/welcomeBlock/welcomeBlock";
import { StaticImageData } from "next/image";
import ExamplePartnerBlock from "./Components/Block_Components/partnerBlock/partner";
import { LanguageProvider, useLanguage } from "./LanguageContext";
import dataLoader from "@/utils/fetchSingleType";
import PartnerBlock from "./Components/Block_Components/partnerBlock/partner";
import { FAQ } from "./Components/Block_Components/faq/FAQ";
import OverView from "./Components/Block_Components/overview/OverView";
import OverViewBlock from "./Components/Block_Components/overview/OverView";
import SlideBlock from "./Components/Block_Components/slideSection/SlideBlock";
import { use } from "react";
import { projectGetSourceForAsset } from "next/dist/build/swc/generated-native";
import { getBaseUrl, getPublicBaseUrl } from "@/lib/getBaseURL";
import { collectionLoader } from "@/utils/fetchCollection";
interface FAQItem {
  question: string;
  answer: string | React.ReactNode;
}
interface Partner {
  src: string; // Change the type of src to StaticImageData
  alt: string;
  width?: number;
  height?: number;
}
// test change 
interface HomePageData {
  welcomeMessage: {
  name:string,
    governerName: string;
    governerPosition: string;
    governerShortMessage: string;
    governerImage: {
      url: string;
    };
  };
  heroBlock: [
    {
      title: string;
      subTitle: string;
      heroBackground: [
        {
          url: string;
        }
      ];
    }
  ];
  InstituteInformation: {
    overview: string;
    focusArea: [
      {
        title: string;
        description: string;
        link: string;
      }
    ];
  };
}
//  const bannerLogos: Partner[] = [
//   { src: logo2.src, alt: 'Partner Logo 2', width: 1200, height: 400  },
//   { src: logo1.src, alt: 'Partner Logo 1', width: 1200, height: 400 },
//   { src: logo3.src, alt: 'Global Green Growth Institute', width: 1200, height: 400 },
//   {src:logo4.src,alt:'collaboration',width:1200,height:400}
//   //{ src: logo4.src, alt: 'Partner Logo 3', width: 600, height: 400  },
// ];

interface Slide {
  id: number;
  imageSrc: string | StaticImageData;
  altText: string;
}
const breadcrumbLinks: { label: string; href: string }[] = [
  { label: "Home", href: "/" },
];

interface StrapiError {
  message: string;
  details?: any; // You might want to be more specific here if Strapi provides structured error details
}

interface HomePageAttributes {
  welcomeMessage?: string;
  // Add other attributes based on your Strapi "home-page" content type
}

interface StrapiResponse<T> {
  data?: {
    id: number;
    attributes: T;
  };
  error?: StrapiError;
}

// const fetchWelcomeMessage = async (): Promise<StrapiResponse<HomePageAttributes>> => {
//   try {
//     const strapiApi = process.env.NEXT_PUBLIC_STRAPI_URL

//     const res = await fetch(`${strapiApi}/api/home-page?populate=*&locale=en`);
//     if (!res.ok) {
//       const errorData = await res.json();
//       console.error(`Failed to fetch welcome message: ${res.status}`, errorData);
//       return { error: { message: `HTTP error! status: ${res.status}`, details: errorData } };
//     }
//     const data: StrapiResponse<HomePageAttributes> = await res.json();
//     console.log(data.data);
//     return data;
//   } catch (error: any) { // It's okay to use `any` here for the generic catch, or you can use `unknown` and narrow it down
//     console.error("Error fetching welcome message:", error);
//     return { error: { message: 'An unexpected error occurred', details: error.message } };
//   }
// }

interface TeamMember {
  image: string;
  name: string;
  title: string;
  description: string;
  level: number;
}
interface Stastics {
  value: string;
  title: string;
}


// Remove the HomePageProps interface as it's not directly used with the default export in this SSR setup
// interface HomePageProps {
//   welcomeData: StrapiResponse<HomePageAttributes>;
// }

// The default export for a Next.js page that uses getServerSideProps or getStaticProps
// should be the component itself, not a function that returns the component.
const Home = () => {
  const [stastics,setStastics] = useState<Stastics[]>([{
     title:'',
     value:''
  }])
  const {language} = useLanguage()
  const [data, setData] = useState<HomePageData>({
    welcomeMessage: {
      name:'',
      governerName: "",
      governerPosition: "",
      governerShortMessage: "",
      governerImage: {
        url: "",
      },
    },
    heroBlock: [
      {
        title: "",
        subTitle: "",
        heroBackground: [
          {
            url: "",
          },
        ],
      },
    ],
    InstituteInformation: {
      overview: "",
      focusArea: [
        {
          title: "",
          description: "",
          link:""
        },
      ],
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      const response = await dataLoader<HomePageData>("home-page",language);
      setData(response);
      console.log("Fetched data:", response.welcomeMessage.governerImage.url);
    };
    const fetchStat  = async() => {
      const response  = await collectionLoader<Stastics>("stastics",language) 
      setStastics(response)
    }  
    fetchData();
    fetchStat()
    
  }, []);
  // const welcomeData = await fetchWelcomeMessage();

  return (
    <div className="container max-w-screen overflow-hidden">
      <HeroBlock />

      {/* <WelcomeBlock
        motto='Kombolcha, the Industrial Capital of Ethiopia '
        governorImage={`${getBaseUrl()}/uploads/thumbnail_Trump_Portrait_5fbba039cd.jpg`}
        governorName="Donald Trump"
        message={welcomeData.data?.attributes?.welcomeMessage || "This is a default message"}
        overview="Kombolcha is one of Ethiopia’s fastest-growing industrial and commercial cities, strategically located along the Addis Ababa-Djibouti corridor, the country’s main trade route. As home to the Kombolcha Industrial Park, the city is a prime destination for investors in manufacturing, textiles, and agro-processing, benefiting from attractive government incentives. Read More"
        mission="This is the mission of the president"
        vision="This is the vision of the president"
        coreValues={["value1", "value2", "value3"]}
      /> */}
      {/* <SlideBlock background={data.heroBlock}
      autoplay={true}
           autoplayInterval={2000}
      /> */}
      <StatisticsGrid
            stats={stastics.map((s, i) => ({
              ...s,
              value: Number(s.value),
              index: i,
            }))}
      />
      <OverViewBlock
        name = {`${data.welcomeMessage.name}`}
        governorImage={`${getPublicBaseUrl()}${data.welcomeMessage.governerImage.url}`}
        governorName={data.welcomeMessage.governerName}
        governerPosition={data.welcomeMessage.governerPosition}
        message={data.welcomeMessage.governerShortMessage}
        // message={welcomeData.data?.attributes?.welcomeMessage || "This is a default message"}
        overview={data.InstituteInformation.overview}
        focusArea={data.InstituteInformation.focusArea}
        // digital=" Driving the adoption of digital solutions to enhance government services, businesses, and everyday life."
        // industrial="Ensuring a secure digital environment by safeguarding national data and strengthening cyber resilience."
        // tech=" Supporting research, startups, and emerging technologies to accelerate economic growth."
        // ict="Establishing clear guidelines and policies to promote responsible and inclusive technology adoption."
        // coreValues={["Integrity", "Accountability", "Service Excellence"]}
      />
      <ServicesSection />
      <NewsSection />

      {/* <PartnerBlock /> */}
      <FAQ/>
      <ContactsSection />
    </div>
  );
};

// If you need to pass props fetched server-side, you would typically use
// getServerSideProps or getStaticProps. Since you are directly fetching in the component,
// the default export is the component itself.

export default Home;

// Example of using getServerSideProps (if you prefer this pattern):
//
// export const getServerSideProps = async () => {
//   const welcomeData = await fetchWelcomeMessage();
//
//   return {
//     props: {
//       welcomeData,
//     },
//   };
// };
//
// interface HomePageProps {
//   welcomeData: StrapiResponse<HomePageAttributes>;
// }
//
// const Home: React.FC<HomePageProps> = ({ welcomeData }) => {
//   return (
//     <div>
//       {/* ... your component JSX using welcomeData */}
//       <WelcomeBlock
//         message={welcomeData.data?.attributes?.welcomeMessage || "Default Message"}
//         // ... other props
//       />
//       {/* ... */}
//     </div>
//   );
// };
//
// export default Home;
